import React from 'react'

const TONES = {
  primary: { tile: 'bg-primary bg-opacity-5', value: 'text-primary', icon: 'bg-primary' },
  success: { tile: 'bg-success bg-opacity-5', value: 'text-success', icon: 'bg-success' },
  danger: { tile: 'bg-danger bg-opacity-5', value: 'text-danger', icon: 'bg-danger' },
  purple: { tile: 'bg-purple bg-opacity-5', value: 'text-purple', icon: 'bg-purple' }
}

const TINTED_TONES = {
  neutral: { tile: 'bg-background', text: 'text-dark-blue', iconBg: 'bg-primary bg-opacity-10', icon: 'text-primary' },
  info: { tile: 'bg-primary bg-opacity-10', text: 'text-primary', iconBg: 'bg-primary bg-opacity-20', icon: 'text-primary' },
  success: { tile: 'bg-success bg-opacity-10', text: 'text-success', iconBg: 'bg-success bg-opacity-20', icon: 'text-success' },
  purple: { tile: 'bg-purple bg-opacity-10', text: 'text-purple', iconBg: 'bg-purple bg-opacity-20', icon: 'text-purple' },
  danger: { tile: 'bg-danger bg-opacity-10', text: 'text-danger', iconBg: 'bg-danger bg-opacity-20', icon: 'text-danger' }
}

export default function StatTile({ icon: Icon, label, value, sub, caption, tone = 'primary', tinted = false }) {
  if (tinted) {
    const { tile, text, iconBg, icon: iconColor } = TINTED_TONES[tone] || TINTED_TONES.neutral

    return (
      <div className={`w-full rounded-xl p-3 flex flex-col gap-2 ${tile}`}>
        <div className="flex items-center justify-between gap-3.5">
          <p className={`text-sm font-semibold ${text}`}>{label}</p>

          {
            Icon && (
              <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${iconBg}`}>
                <Icon size={18} className={iconColor} />
              </div>
            )
          }
        </div>

        <div className="flex items-end justify-between">
          <p className={`text-xl font-semibold ${text}`}>{value}</p>
          {sub && <p className="text-sm text-secondary">{sub}</p>}
        </div>

        {caption && <p className="text-sm text-secondary mt-1">{caption}</p>}
      </div>
    )
  }

  const { tile, value: valueColor, icon: iconBg } = TONES[tone] || TONES.primary

  return (
    <div className={`w-full rounded-xl p-4 ${tile}`}>
      <div className="flex items-start justify-between mb-1">
        <p className="text-sm text-secondary">{label}</p>

        {
          Icon && (
            <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 ${iconBg}`}>
              <Icon size={18} className="text-white" />
            </div>
          )
        }
      </div>

      <div className="flex items-end justify-between">
        <p className={`text-xl font-bold ${valueColor}`}>{value}</p>
        {sub && <p className="text-sm text-secondary">{sub}</p>}
      </div>

      {caption && <p className="text-sm text-secondary mt-1">{caption}</p>}
    </div>
  )
}
